import React from "react";
import MetricCard from "./MetricCard";
import { useDashboard } from "../../context/DashboardContext";

const MetricsSection = () => {
  const { metrics } = useDashboard();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <MetricCard
        title="Current streak"
        subtitle={`From ${metrics.currentStreak.from}`}
        value={`${metrics.currentStreak.days} days`}
        percentage={95}
        color="emerald"
      />

      <MetricCard
        title="Longest streak"
        subtitle={`${metrics.longestStreak.period.from} - ${metrics.longestStreak.period.to}`}
        value={`${metrics.longestStreak.days} days`}
        percentage={100}
        color="emerald"
      />

      <MetricCard
        title="Most profitable day"
        subtitle={metrics.mostProfitableDay.date}
        value={`${metrics.mostProfitableDay.value}`.replace("₹", "")}
        isMonetary={true}
        color="emerald"
      />
    </div>
  );
};

export default MetricsSection;
